import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgLinkChain(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M26.3209 4.87786C23.56 2.11685 19.0977 2.0091 16.3551 4.75174L13.5803 7.5265L15.3481 9.29426L18.1228 6.5195C19.8383 4.80406 22.7168 4.80926 24.5532 6.64562C26.3895 8.482 26.3947 11.3606 24.6793 13.076L20.6433 17.1121C18.9279 18.8275 16.0493 18.8223 14.213 16.9859L12.4452 18.7537C15.2062 21.5147 19.6685 21.6225 22.4111 18.8798L26.4471 14.8438C29.1897 12.1012 29.0819 7.63888 26.3209 4.87786Z"
      />
      <path
        fill="currentColor"
        d="M10.555 14.0871C12.2704 12.3717 15.149 12.3769 16.9853 14.2133L18.7531 12.4455C15.9921 9.68447 11.5298 9.57673 8.78723 12.3194L4.75123 16.3554C2.00862 19.098 2.11636 23.5603 4.87736 26.3213C7.63835 29.0823 12.1006 29.1901 14.8432 26.4474L17.618 23.6727L15.8502 21.9049L13.0755 24.6797C11.3601 26.3951 8.48148 26.3899 6.64513 24.5536C4.80877 22.7172 4.80358 19.8386 6.519 18.1231L10.555 14.0871Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgLinkChain);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
